import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../axiosapi';
import DiscussionCard from '../../Discussion/DiscussionCard';
import { useModuleContext } from '../../../context/ModuleProvider';
import './Discussion.css';

const Discussion = () => {
  let { moduleId, url } = useModuleContext();
  let [discussion, setDiscussion] = useState();
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [initialLoading, setInitialLoading] = useState(false);
  const [infiniteLoading, setInfiniteLoading] = useState(false);

  const discussionRef = React.useRef(null);

  const getDisscussions = () => {
    page === 1 ? setInitialLoading(true) : setInfiniteLoading(true);
    axiosInstance({
      method: 'get',
      url: `${url}/discussion?page=${page}&search=${debouncedSearch}`,
    })
      .then((res) => {
        setInitialLoading(false);
        setInfiniteLoading(false);
        setDiscussion((prevDiscussion) => {
          if (page === 1) {
            return res.data.discussion;
          }
          return [...prevDiscussion, ...res.data.discussion];
        });
        setTotalPages(res.data.total_pages || 1);
      })
      .catch((err) => {
        setInitialLoading(false);
        setInfiniteLoading(false);
        console.error(err);
      });
  };

  useEffect(() => {
    getDisscussions();
  }, [debouncedSearch, page]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
      setPage(1); // Reset page to 1 when search changes
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  const addVote = (discussion_id, check) => {
    if (!check) {
      axiosInstance({
        method: 'post',
        url: `${url}/discussion/t/vote`,

        data: { type: 1, discussion_id },
      }).then((res) => {
        if (!res.data.error) {
          let data = res.data;
          let newDiscussion = discussion.map((d) => {
            if (d.discussion_id === discussion_id) {
              d.vote = data.vote;
              d.type = data.type;
            }
            return d;
          });
          setDiscussion(newDiscussion);
        } else {
          alert(res.data.error);
        }
      });
    }
  };

  return (
    <div>
      <form>
        <input
          type="text"
          className="input"
          placeholder="Search discussions..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </form>
      {initialLoading ? (
        Array.from({ length: 3 }).map((_, index) => <SkeletonLoader key={index} />)
      ) : (
        <>
          <div
            ref={discussionRef}
            className="info-box-discussion"
            onScroll={() => {
              if (
                discussionRef.current.scrollTop + discussionRef.current.clientHeight >=
                discussionRef.current.scrollHeight
              ) {
                if (page < totalPages) {
                  setPage((prevPage) => prevPage + 1);
                }
              }
            }}
          >
            <DiscussionCard addVote={addVote} discussion={discussion} moduleId={moduleId} />
            {infiniteLoading && <SkeletonLoader />}
          </div>
        </>
      )}
    </div>
  );
};

function SkeletonLoader() {
  return (
    <div className="qa-card-skeleton w-100">
      <div className="header">
        <div className="skeleton avatar" />
        <div className="user-info">
          <div className="skeleton name" />
          <div className="skeleton date" />
        </div>
        <div className="skeleton tag" />
      </div>
      <div className="skeleton title" />
      <div className="skeleton message" />
      <div className="footer">
        <div className="skeleton reaction" />
        <div className="skeleton reaction" />
      </div>
    </div>
  );
}

export default Discussion;
